import Vue from 'vue';

if (document.querySelector('#lists-index-vue')) {
    name: 'List Page',
    new Vue({
        el: '#lists-index-vue'
    });
}

// Add to Lists
if (document.querySelector('#add-to-list-vue')) {

    new Vue({
        name: 'Add to List',
        el: '#add-to-list-vue'
    });
}
